<template>
  <admin-wrapper hide-title-row disable-sticky-buttons :custom-saving="loading" :inputs="inputs" @save="save">
    <template #max_layers_limit.input.inner.bottom>
      <v-row no-gutters>
        <v-checkbox
          class="ma-0"
          v-model="limitOnlyFeatureLayers"
          v-bind="limitOnlyFeatureLayersInput"
          @change="changes = true"
        >
          <template #label>
            <span class="text-body-2 font--text">
              {{ limitOnlyFeatureLayersInput.label }}
            </span>
          </template>
        </v-checkbox>
      </v-row>
    </template>
  </admin-wrapper>
</template>
<script>
import { call } from 'vuex-pathify';
import AdminWrapper from '@/components/AdminWrapper';
export default {
  name: 'SuperAdminLimitationsSettings',
  components: { AdminWrapper },
  computed: {
    inputs() {
      return [
        {
          name: 'max_users_limit',
          translationPath: 'admin.maxUsersLimit',
          dataType: { name: 'integer' },
          rules: [v => v === 0 || !!v || 'rules.required'],
          allowNegative: false,
        },
        {
          name: 'max_layers_limit',
          translationPath: 'admin.maxLayersLimit',
          dataType: { name: 'integer' },
          rules: [v => v === 0 || !!v || 'rules.required'],
          allowNegative: false,
          hideDetails: true,
        },
      ];
    },
    limitOnlyFeatureLayersInput() {
      return {
        name: 'limit_only_feature_layers',
        label: this.$i18n.t('admin.limitOnlyFeatureLayers'),
      };
    },
  },
  data: () => ({
    changes: false,
    loading: false,
    limitOnlyFeatureLayers: false,
  }),
  methods: {
    editSingleSetting: call('admin/editSingleSetting'),
    async save() {
      if (this.changes) {
        this.loading = true;
        try {
          await this.editSingleSetting({
            key: this.limitOnlyFeatureLayersInput.name,
            body: { value: this.limitOnlyFeatureLayers },
          });
          this.changes = false;
        } finally {
          this.loading = false;
        }
      }
    },
  },
  mounted() {
    this.limitOnlyFeatureLayers = this.$store.get('admin.settingsValues')?.limit_only_feature_layers || false;
  },
};
</script>
